import type { ReactNode } from 'react';
import { clsx } from 'clsx';

type Props = {
  children: ReactNode;
  className?: string;
  dotColor?: 'lime' | 'terracotta' | 'white';
};

const DOT_COLORS: Record<NonNullable<Props['dotColor']>, string> = {
  lime: 'bg-lime-500',
  terracotta: 'bg-terracotta-500',
  white: 'bg-white',
};

export function MarketingHeroPill({ children, className, dotColor = 'lime' }: Props) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-[10px] border-2 border-charcoal-800 bg-white px-[14px] py-[6px] font-marketing-mono text-[11px] font-medium uppercase tracking-[0.08em] text-charcoal-800 shadow-neobrutal-2',
        className,
      )}
    >
      <span
        className={clsx(
          'h-2 w-2 rounded-full border border-charcoal-800 animate-[pulse_2s_ease-in-out_infinite]',
          DOT_COLORS[dotColor],
        )}
      />
      {children}
    </span>
  );
}
